import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import Dashboard from './dashboard';
import { getSiteList, getInvoiceList, saveInvoiceData, getCSV, getLateFee, setInstallmentFee,getInvoiceListBySiteNumber } from "../../../services/redux/brandActivtion/baDashboard/action";

const mapStateToProps = (state) => ({
  dashboardSiteListing: state.BaDashboardReducer.dashboardSiteListing,
  dashboardInvoiceListing: state.BaDashboardReducer.dashboardInvoiceListing,
  lateFee: state.BaDashboardReducer.lateFee,
  dropdownInvoiceListing: state.BaDashboardReducer.dropdownInvoiceListing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteList, getInvoiceList, saveInvoiceData, getCSV, getLateFee, setInstallmentFee, getInvoiceListBySiteNumber
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);

